import { useEffect, useState } from 'react';

export interface ExpandableItemParams {
	areAllItemsExpanded: boolean;
	handleItemExpandedChange: (expanded: boolean) => void;
}

/**
 * Manages the state for a single item among a list of items that can be expanded.
 * Ensures it is wired up to external expand state (e.g. via an "Expand All" button).
 */
export default function useExpandableItem({
	areAllItemsExpanded,
	handleItemExpandedChange,
}: ExpandableItemParams) {
	const [isExpanded, setIsExpanded] = useState(areAllItemsExpanded);

	useEffect(() => {
		setIsExpanded(areAllItemsExpanded);
	}, [areAllItemsExpanded]);

	const handleExpandedChange = (expanded: boolean) => {
		setIsExpanded(expanded);
		handleItemExpandedChange(expanded);
	};

	return {
		isExpanded,
		handleExpandedChange,
	};
}
